// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import reactUpdate from 'immutability-helper';
import React from 'react';

import {CRISPRRegion} from 'constants/CRISPRConstants';
import {Chromosome, Genome} from 'constants/GenomeConstants';
import {StrandOfDoubleStranded} from 'constants/MolbioConstants';
import GenomeRegionSelector from 'molbio/genome/GenomeRegionSelector';
import * as sequtil from 'molbio/SeqUtil';
import notifications from 'notifications';
import getTestProps from 'test/lib/cypress/getTestProps';
import ModalButtonKey from 'test/lib/cypress/shared/ModalButtonKey';
import FormGroup from 'ui-library/bs/FormGroup';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Modal from 'ui-library/modals/Modal';
import PopoverIcon from 'ui-library/PopoverIcon';
import runModal from 'ui-library/runModal';
import * as GenomeUtil from 'util/GenomeUtil';
import * as TaskRunner from 'util/TaskRunner';
import {InputChangeEvent} from 'util/Types';

const {locationToName} = GenomeUtil;

interface GenomeMatch {
  start: number;
  end: number;
  chromosome: Chromosome;
  strand: StrandOfDoubleStranded;
  matches: number;
}

export type GenomeRegionData = Pick<
  CRISPRRegion,
  'genomeRegionStart' | 'genomeRegionEnd' | 'genomeRegionChromosome'
>;

const NO_CHROMOSOME = 'NO_CHROMOSOME';
const MANUAL_CHROMOSOME = 'MANUAL_CHROMOSOME';

type RegionChoice = typeof NO_CHROMOSOME | typeof MANUAL_CHROMOSOME | string | number;

interface SetGenomeRegionModalProps {
  region: CRISPRRegion;
  genome: Genome;
  updateRegion: (regionId: string, region: GenomeRegionData) => void;
  getRegionBases: (region: CRISPRRegion) => string;
  onRequestClose: () => void;
}

interface SetGenomeRegionModalState {
  genomeMatches: Array<GenomeMatch>;
  findingGenomeMatches: boolean;
  regionChoice: RegionChoice;
  workingChromosome?: Chromosome | null;
  workingStart?: number | null;
  workingEnd?: number | null;
}

// Exported for testing.
export class SetGenomeRegionModal extends React.Component<
  SetGenomeRegionModalProps,
  SetGenomeRegionModalState
> {
  _isMounted!: boolean;
  state: SetGenomeRegionModalState = {
    genomeMatches: [],
    findingGenomeMatches: false,
    regionChoice: this.props.region.genomeRegionChromosome != null ? MANUAL_CHROMOSOME : NO_CHROMOSOME,
    workingChromosome: this.props.region.genomeRegionChromosome,
    workingStart: this.props.region.genomeRegionStart,
    workingEnd: this.props.region.genomeRegionEnd,
  };

  componentDidMount(): void {
    this._isMounted = true;
  }

  componentWillUnmount(): void {
    this._isMounted = false;
  }

  runGenomeMatch = (): void => {
    this.setState({findingGenomeMatches: true});
    TaskRunner.runTask({
      url: '/1/api/match-genomic-region',
      method: 'PUT',
      contentType: 'application/json',
      data: JSON.stringify({
        genome_name: this.props.genome.ensemblName,
        bases: this.props.getRegionBases(this.props.region),
      }),
    })
      .fail(notifications.notifyError)
      .done((resp) => {
        if (!this._isMounted) {
          return;
        }
        if (resp.length === 0) {
          notifications.warn('No genome matches were found for the current target region.');
        }
        this.setState({genomeMatches: resp});
      })
      .always(() => {
        if (this._isMounted) {
          this.setState({findingGenomeMatches: false});
        }
      });
  };

  setRegionChoice = (e: InputChangeEvent): void => {
    const regionChoice: string = e.target.value;
    if ([NO_CHROMOSOME, MANUAL_CHROMOSOME].includes(regionChoice)) {
      this.setState({regionChoice});
    } else {
      // Region choice is the index of a matching chromosome in this case.
      this.setState({regionChoice: Number.parseInt(regionChoice, 10)});
    }
  };

  setChromosome = (chromosome: Chromosome): void => {
    this.setState({workingChromosome: chromosome});
    this.setManualChromosome();
  };

  setWorkingStart = (e: InputChangeEvent): void => {
    let value: number | null = Number.parseInt(e.target.value, 10);
    if (Number.isNaN(value)) {
      value = null;
    } else {
      value = sequtil.displayStartToModel(value, 1);
    }
    this.setState({workingStart: value});
    this.setManualChromosome();
  };

  setWorkingEnd = (e: InputChangeEvent): void => {
    let value: number | null = Number.parseInt(e.target.value, 10);
    if (Number.isNaN(value)) {
      value = null;
    } else {
      value = sequtil.displayEndToModel(value, value + 1, 1);
    }
    this.setState({workingEnd: value});
    this.setManualChromosome();
  };

  setManualChromosome = (): void => {
    this.setState({regionChoice: MANUAL_CHROMOSOME});
  };

  enableSave = (): boolean => {
    if (this.state.regionChoice === MANUAL_CHROMOSOME) {
      return (
        this.state.workingStart != null &&
        this.state.workingEnd != null &&
        this.state.workingChromosome != null &&
        sequtil.isValidRange(
          this.state.workingStart,
          this.state.workingEnd,
          this.state.workingChromosome.length,
          false
        )
      );
    }
    return true;
  };

  saveGenomeRegion = (): void => {
    const newRegion = reactUpdate(this.props.region, {
      $merge: (() => {
        switch (this.state.regionChoice) {
          case MANUAL_CHROMOSOME:
            return {
              genomeRegionChromosome: this.state.workingChromosome,
              genomeRegionStart: this.state.workingStart,
              genomeRegionEnd: this.state.workingEnd,
            };
          case NO_CHROMOSOME:
            return {
              genomeRegionChromosome: null,
              genomeRegionStart: null,
              genomeRegionEnd: null,
            };
          default: {
            // Choice is an index into matches.
            const match = this.state.genomeMatches[Number.parseInt(this.state.regionChoice as string, 10)];
            return {
              genomeRegionChromosome: match.chromosome,
              genomeRegionStart: match.start,
              genomeRegionEnd: match.end,
            };
          }
        }
      })(),
    });
    this.props.updateRegion(this.props.region.id, newRegion);
    this.props.onRequestClose();
  };

  render(): JSX.Element {
    return (
      <Modal
        title="Genome region"
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this.saveGenomeRegion}
        buttons={[
          {text: 'Set genome region', submit: true, disabled: !this.enableSave(), key: ModalButtonKey.APPLY},
          {text: 'Cancel', cancel: true},
        ]}
      >
        <p>Setting a genome region will remove it from off-target analysis.</p>
        <div className="radio">
          <label>
            <input
              type="radio"
              name="genomeRegionOptions"
              value={NO_CHROMOSOME}
              checked={this.state.regionChoice === NO_CHROMOSOME}
              onChange={this.setRegionChoice}
            />
            None
          </label>
        </div>
        <div className="radio">
          <label className={css(SetGenomeRegionModalStyles.wrapper)}>
            <input
              type="radio"
              name="genomeRegionOptions"
              value={MANUAL_CHROMOSOME}
              checked={this.state.regionChoice === MANUAL_CHROMOSOME}
              onChange={this.setRegionChoice}
            />
            <GenomeRegionSelector
              className={classNames('u-small-spacing-left', css(SetGenomeRegionModalStyles.childLarge))}
              onChange={this.setChromosome}
              value={this.state.workingChromosome!}
              genome={this.props.genome}
            />
            <input
              className={classNames('u-small-spacing-left', css(SetGenomeRegionModalStyles.childSmall))}
              type="number"
              placeholder="Start (bp)"
              value={sequtil.modelStartToDisplay(this.state.workingStart, 1)!}
              onChange={this.setWorkingStart}
            />
            <input
              className={classNames('u-small-spacing-left', css(SetGenomeRegionModalStyles.childSmall))}
              type="number"
              placeholder="End (bp)"
              value={sequtil.modelEndToDisplay(this.state.workingEnd, this.state.workingEnd! + 1, 1)!}
              onChange={this.setWorkingEnd}
            />
          </label>
        </div>
        {Array.from(this.state.genomeMatches).map((match, i) => (
          // Just using `i` for key because there's no state
          <div key={i} className="radio">
            <label>
              <input
                type="radio"
                name="genomeRegionOptions"
                value={i}
                checked={this.state.regionChoice === i}
                onChange={this.setRegionChoice}
              />
              {locationToName(match.chromosome, match.start, match.end, match.strand)}
              {` (${match.matches} matches)`}
            </label>
          </div>
        ))}
        <FormGroup>
          <Button
            dataTestAttrs={{component: 'SetGenomeRegionModal', element: 'findMatchesButton'}}
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            size={ButtonSize.SMALL}
            onClick={this.runGenomeMatch}
            disabled={this.state.findingGenomeMatches || this.props.genome.ucscName == null}
            text={this.state.findingGenomeMatches ? 'Finding...' : 'Find genome matches'}
          />
          {this.props.genome.ucscName == null ? (
            <PopoverIcon
              className="u-input-line-height u-warning-color u-small-spacing-left"
              icon="warning"
              renderContent={() => 'Matching regions cannot be automatically found for this genome.'}
              placement={FloatingPlacement.RIGHT}
            />
          ) : undefined}
        </FormGroup>
      </Modal>
    );
  }
}

const SetGenomeRegionModalStyles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  childSmall: {
    flex: 1,
  },
  childLarge: {
    flex: 3,
  },
});

interface Props {
  allowEdits: boolean;
  region: CRISPRRegion;
  genome: Genome;
  getRegionBases: (region: CRISPRRegion) => string;
  updateRegion: (regionId: string, region: GenomeRegionData) => void;
}

export default function GenomeRegionLabel({allowEdits, ...props}: Props): JSX.Element {
  let genomeRegionText: string;
  if (props.region.genomeRegionChromosome != null) {
    const {genomeRegionChromosome, genomeRegionStart, genomeRegionEnd} = props.region;
    genomeRegionText = locationToName(genomeRegionChromosome, genomeRegionStart!, genomeRegionEnd!);
  } else {
    genomeRegionText = 'No region set';
  }

  if (allowEdits) {
    return (
      <a
        onClick={() => runModal(SetGenomeRegionModal, props)}
        {...getTestProps({component: 'GenomeRegionLabel', element: 'regionText'})}
      >
        {genomeRegionText}
      </a>
    );
  } else {
    return (
      <span {...getTestProps({component: 'GenomeRegionLabel', element: 'regionText'})}>
        {genomeRegionText}
      </span>
    );
  }
}
